
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-0.75 -0.75 24 24","height":"24","width":"24","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.766 15.469a1.406 1.406 0 102.812 0 1.406 1.406 0 10-2.812 0","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M17.366 10.031l.416 1.361a.93.93 0 001.1.639l1.38-.32a1.255 1.255 0 011.195 2.08l-.966 1.041a.938.938 0 000 1.277l.966 1.042a1.255 1.255 0 01-1.195 2.08l-1.38-.32a.932.932 0 00-1.1.638l-.416 1.357a1.247 1.247 0 01-2.388 0l-.415-1.362a.938.938 0 00-1.1-.638l-1.38.32a1.255 1.255 0 01-1.195-2.08l.966-1.042a.938.938 0 000-1.277l-.966-1.041a1.254 1.254 0 011.195-2.08l1.38.32a.93.93 0 001.1-.638l.415-1.361a1.247 1.247 0 012.388.004z","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M21.572 8.776a4.564 4.564 0 00-6.938-2.344 7.031 7.031 0 10-6.9 8.334","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    